import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import ContentHeader from '../../../../Layout/ContentHeader'
import Loader from '../../../../Global/Spinner'
import Box from '../../../../Global/Box'
import { backPage } from '../Status'
import StatusTransitions from './StatusTransitions/StatusTransitions'
import StatusRoles from './StatusRoles/StatusRoles'
import {
  GET_ALL_STATUS,
  GET_ONE_STATUS,
} from '../../../../../graphql/Catalog/Status/status'

const StatusDetails = () => {
  const { id: _id } = useParams()

  const [data, setData] = useState(null)

  const {
    data: dataResp,
    loading,
    error,
  } = useQuery(GET_ONE_STATUS, {
    variables: { id: parseInt(_id) },
    fetchPolicy: 'no-cache',
  })

  useEffect(() => {
    if (!loading) {
      if (_id) {
        if (error) {
          return toastSweetAlert({
            mode: 'error',
            message: error.message,
          })
        }
        if (dataResp !== undefined && dataResp !== null) {
          const resp = dataResp.getOneCatalogStatus
          setData(resp)
        }
      }
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_id, dataResp, error, loading])

  return (
    <>
      <ContentHeader
        title=""
        titleContent={
          <div className="col-12">
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <div>
                <Link
                  className="btn btn-migrates-white mb-3"
                  to={backPage}
                >
                  <i className="fas fa-long-arrow-alt-left" /> Atrás
                </Link>
                <h1 className="header-title">Estatus</h1>
              </div>
            </div>
          </div>
        }
        breadcrumb=""
        windowTitle={`Detalle de estatus`}
      />

      {loading || !data ? (
        <div className="d-flex align-items-center justify-content-center">
          <Loader />
        </div>
      ) : (
        <div className="reports">
          <Box
            classNameHeader="card-header py-1"
            contentHeader={
              <h3 className="card-title pl-3 mt-0">Datos generales</h3>
            }
            content={
              <>
                <div
                  className="d-flex flex-column flex-wrap"
                  style={{ gap: '5px' }}
                >
                  <BoxItemData title="TIPO" value={data?.type} />
                  <BoxItemData title="NOMBRE" value={data?.name} />
                  <BoxItemData
                    title="PROGRESO"
                    value={data?.progress ? `${data.progress}%` : 'N/A'}
                  />
                  <BoxItemData
                    title="COLOR"
                    value={
                      data?.color && (
                        <div
                          className="rounded"
                          style={{
                            backgroundColor: `${data.color}`,
                            width: '75px',
                            height: '20px',
                          }}
                        ></div>
                      )
                    }
                  />
                  <BoxItemData title="ORDEN" value={data?.order} />
                  <BoxItemData title="DESCRIPCION" value={data?.description} />
                </div>
              </>
            }
          />
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-6">
              <StatusTransitions
                current_status_id={parseInt(_id)}
                dataCurrentStatus={data}
              />
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-6">
              <StatusRoles
                current_status_id={parseInt(_id)}
                dataCurrentStatus={data}
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export const BoxItemData = ({ title, value }) => {
  return (
    <div className="rounded border-3 border d-flex align-items-center">
      <div className="px-2 rounded" style={{ backgroundColor: '#d1d1d1' }}>
        <small className="text-black">{title}</small>
      </div>
      <div className="px-2">{value || 'N/A'}</div>
    </div>
  )
}

export default StatusDetails
